import React, { useState, useRef, useEffect } from "react";
import { ExternalLink } from "lucide-react";

const OptimizedIframe = ({ url, title }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const iframeRef = useRef(null);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setError("Failed to load iframe content");
    setIsLoading(false);
  };

  const handleOpenNewTab = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (!url?.trim()) {
    return (
      <div className="w-full min-h-[400px] bg-gray-50 rounded-lg flex items-center justify-center text-red-500">
        URL is required
      </div>
    );
  }

  return (
    <div className="relative w-full min-h-[400px] bg-gray-50 border border-[#D9D9D9] rounded group">
      {/* New Tab Button */}
      <button
        onClick={handleOpenNewTab}
        className="absolute top-2 right-2 z-10 p-2 bg-white/90 hover:bg-white rounded-lg shadow-md 
                 flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 
                 transition-opacity duration-200 opacity-0 group-hover:opacity-100"
      >
        <ExternalLink size={16} />
        Open in new tab
      </button>

      {isLoading && (
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="w-8 h-8 border-4 border-[#006b4f] border-t-transparent rounded-full animate-spin mb-4"></div>
          <div className="text-sm text-gray-500">Loading...</div>
        </div>
      )}

      <iframe
        ref={iframeRef}
        src={url}
        title={title || "Embedded content"}
        onLoad={handleLoad}
        onError={handleError}
        className={`w-full h-[400px] rounded-lg shadow-md ${
          isLoading ? "opacity-0" : "opacity-100"
        }`}
        loading="lazy"
        sandbox="allow-scripts allow-same-origin"
        referrerPolicy="no-referrer"
      />
    </div>
  );
};

export default OptimizedIframe;